import { faFillDrip, faXmark } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import {
  editorButtonToggle,
  editorCellColorPalette,
  editorCellColorSwatch,
  editorCellColorWrapper,
  editorTableMenuDanger
} from './EditorInput.css'

const CELL_COLORS = [
  { label: 'Blanc', value: '#ffffff' },
  { label: 'Gris clair', value: '#F5F8F9' },
  { label: 'Bleu clair', value: '#E3EAEC' },
  { label: 'Rouge clair', value: '#FFEBEE' },
  { label: 'Rose', value: '#FFDADF' },
  { label: 'Vert clair', value: '#E8F5F1' },
  { label: 'Jaune', value: '#FDFAF0' },
  { label: 'Jaune foncé', value: '#F5E4B6' },
  { label: 'Orange clair', value: '#FCF0D0' },
  { label: 'Gris', value: '#D0DADD' }
]

export const CellColorPicker = ({ editor }: { editor: Editor }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    if (open) document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [open])

  const applyColor = (color: string | null) => {
    editor.chain().focus().setCellAttribute('backgroundColor', color).run()
    setOpen(false)
  }

  return (
    <div ref={ref} className={editorCellColorWrapper}>
      <Tooltip direction="bottom" text="Couleur de la cellule" asChild>
        <button
          type="button"
          className={editorButtonToggle}
          onClick={() => setOpen((v) => !v)}
        >
          <FontAwesomeIcon icon={faFillDrip} />
        </button>
      </Tooltip>
      {open && (
        <div className={editorCellColorPalette}>
          {CELL_COLORS.map(({ label, value }) => (
            <button
              key={value}
              type="button"
              title={label}
              className={editorCellColorSwatch}
              style={{ backgroundColor: value }}
              onClick={() => applyColor(value)}
            />
          ))}
          <button
            type="button"
            title="Supprimer la couleur"
            className={clsx(editorCellColorSwatch, editorTableMenuDanger)}
            style={{ backgroundColor: 'transparent' }}
            onClick={() => applyColor(null)}
          >
            <FontAwesomeIcon
              icon={faXmark}
              style={{ fontSize: 10, width: '100%' }}
            />
          </button>
        </div>
      )}
    </div>
  )
}
